import { Drawer, Grid, Stack } from '@mui/material';
import useConfig from '@hooks/useConfig';
import { useDashboardSelector } from '@hooks/useDashboard';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme, useTheme } from '@mui/material/styles';
import MainCard from '@components/ui/cards/MainCard';
import { ThemeMode } from '@app/types/config';
import CardContent from '@mui/material/CardContent';
import { gridSpacing } from '@shared/constants/theme';
import AnimateButton from '@components/extended/AnimateButton';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { IconX } from '@tabler/icons-react';
import NotificationList from '@components/NotificationPreview/ui/NotificationList';

function NotificationDrawer() {
  const { mode } = useConfig();
  const theme = useTheme();
  const toggleNotificationOpened = useDashboardSelector(
    (state) => state.toggleNotificationOpened
  );
  const isNotificationOpened = useDashboardSelector(
    (state) => state.isNotificationOpened
  );
  const matchDownSM = useMediaQuery((t: Theme) => t.breakpoints.down('xl'));

  return (
    <Drawer
      sx={{
        width: 500,
        flexShrink: 0,
        zIndex: { xs: 1200, xl: 0 },
        ...(!matchDownSM && {
          position: 'sticky',
          top: 0,
          height: '100vh',
        }),
        '& .MuiDrawer-paper': {
          height: !matchDownSM ? '100%' : 'auto',
          width: 500,
          boxSizing: 'border-box',
          position: 'relative',
          border: 'none',
          borderRight: matchDownSM ? 0 : `1px solid #eaecf0`,
        },
      }}
      variant={matchDownSM ? 'temporary' : 'persistent'}
      anchor="left"
      open={isNotificationOpened}
      ModalProps={{ keepMounted: true }}
    >
      {isNotificationOpened && (
        <MainCard
          sx={{
            height: !matchDownSM ? '100%' : 'auto',
            bgcolor:
              mode === ThemeMode.DARK ? 'dark.main' : theme.palette.grey[50],
          }}
          content={false}
          borderRadius={0}
        >
          <CardContent sx={{ height: !matchDownSM ? '100%' : '100vh' }}>
            <Grid container spacing={gridSpacing}>
              <Grid item xs={12}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <h2>Notifications</h2>
                  <AnimateButton>
                    <Tooltip title="Close">
                      <IconButton
                        size="small"
                        onClick={toggleNotificationOpened}
                      >
                        <IconX stroke={1.5} size="20px" />
                      </IconButton>
                    </Tooltip>
                  </AnimateButton>
                </Stack>
              </Grid>
              <Grid item container xs={12} spacing={2}>
                <NotificationList />
              </Grid>
            </Grid>
          </CardContent>
        </MainCard>
      )}
    </Drawer>
  );
}

export default NotificationDrawer;
